import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { TaskDetailPage } from "web_myplann/Tasks/Pages/TaskDetailPage";
import { TaskDetailV2Page } from "web_myplann/Tasks/Pages/TaskDetailV2Page";

export const TaskDetailPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <TaskDetailV2Page /> : <TaskDetailPage />;
};
